import { AxiosResponse } from 'axios';
import { FileDownloadAndNewArrivalNotificationRequest, FileDownloadUrlResponse } from 'types/entity';
import { http } from './settings';

export const fetchFileDownload = (projectId: string, fileDownloadAndNewArrivalNotificationRequest: FileDownloadAndNewArrivalNotificationRequest): Promise<FileDownloadUrlResponse> => http
  .post(`/projects/${projectId}/files`, fileDownloadAndNewArrivalNotificationRequest)
  .then((value: AxiosResponse<FileDownloadUrlResponse>) => value.data || []);
